<template>
  <div
    v-zpm="{ sectionid: 162, sortname: '图片外区域' }"
    class="parts-wrapper"
    @click="select(null)"
  >
    <div class="parts-content" :class="{ other_env: !env }">
      <div v-if="state.accessoryList.length" class="parts-tips">
        <span class="tips-icon">Tips</span>
        <span class="tips-text"
          >本商品自带配件
          <span v-for="(item, index) in state.accessoryList.join('、')" :key="index">{{
            item
          }}</span>
        </span>
      </div>
      <div v-else class="parts-tips no-parts-tips">
        <img
          :src="
            $setPicSize(
              'https://pic4.zhuanstatic.com/zhuanzh/8abb593a-a7d9-48ff-8077-150d8002f322.png'
            )
          "
          alt=""
        />
        <span class="tips-text">{{ parts.tiedSaleProductInfo.noAccessoryText }}</span>
      </div>
      <div class="parts-header">
        <span v-if="state.accessoryList.length" class="title">为你推荐更多好配件</span>
        <span v-else class="title" :class="{ active: state.accessoryList.length == 0 }"
          >搭配买</span
        >
        <span class="select"
          >更多优惠搭配
          <img
            :src="
              $setPicSize(
                'https://pic4.zhuanstatic.com/zhuanzh/db095ccb-6d8a-41e3-b14f-ad4b41c176c9.png'
              )
            "
            alt=""
          />
        </span>
      </div>
      <div v-if="parts.tiedSaleProductInfo.tiedSaleProductList" class="select-cates">
        <div
          v-for="(item, index) in parts.tiedSaleProductInfo.tiedSaleProductList"
          :key="index"
          v-zpm="{ sortname: '图片区域', sortid: index + 1 }"
          class="select-item-wrapper"
          @click.stop="select(item.title, index)"
        >
          <div class="select-item">
            <img class="img-select" :src="$setPicSize(item.pic, 300, 300)" alt="" />
            <div
              v-if="item.buttonInfo && item.buttonInfo.modelIcon && item.buttonInfo.showText"
              class="select-tag"
            >
              <img class="img-tag" :src="$setPicSize(item.buttonInfo.modelIcon, 36, 36)" alt="" />
              <div class="tag-text">{{ item.buttonInfo.showText }}</div>
            </div>
          </div>
          <span class="item-title">{{ item.title }}</span>
          <div v-if="item.price" class="item-price">
            <span class="price-text">{{ `￥${(+item.price * 100) / 10000}元起` }}</span>
            <img
              class="price-icon"
              :src="
                $setPicSize(
                  'https://pic3.zhuanstatic.com/zhuanzh/b291f1fb-b30b-451c-853f-7dd884d9ff27.png'
                )
              "
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import { state } from '@/store'
import { isPlatform } from '@utils/native'
export default defineComponent({
  props: {
    mainImageToolList: {
      type: Array,
      default: () => []
    }
  },

  setup(props, ctx) {
    const env = isPlatform('zz')
    const parts = computed(() => {
      return props.mainImageToolList.filter((item) => item.code === '2')?.[0] || []
    })
    const select = (tabname, index) => {
      ctx.emit('listenMatching', tabname, index)
    }
    return {
      state,
      parts,
      select,
      env
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
@import '@zz-common/zz-ui/lib/style/mixins/ellipsis.scss';
.parts-wrapper {
  position: relative;
  width: 100%;
  height: 100vw;
  background: #f8f8f8f8;
  .parts-content {
    position: absolute;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    width: 686px;
    height: 482px;
    margin-bottom: 80px;
    margin-left: 32px;
    padding: 32px;
    background: #fff;
    border-radius: 16px;
    &.other_env {
      margin-bottom: 165px;
    }
    .parts-tips {
      display: flex;
      align-items: center;
      line-height: 1;
      &.no-parts-tips {
        margin-top: 4px;
      }
      img {
        top: 0;
        width: 18px;
        height: 18px;
        margin-right: 6px;
      }
      .tips-icon {
        display: inline-block;
        width: 56px;
        height: 28px;
        margin-right: 12px;
        color: #111;
        font-weight: 300;
        font-size: 20px;
        font-family: PingFangSC-Light, PingFang SC;
        line-height: 28px;
        text-align: center;
        background: linear-gradient(160deg, #f7deff 0%, #ddfeff 100%);
        border-radius: 4px;
      }
      .tips-text {
        color: #666;
        font-weight: 300;
        font-size: 22px;
        font-family: PingFangSC-Light, PingFang SC;
      }
    }

    .parts-header {
      position: relative;
      display: flex;
      flex-direction: column;
      margin-top: 40px;
      .title {
        position: relative;
        z-index: 1;
        color: #000000;
        font-weight: 400;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 28px;
        &.active {
          margin-bottom: 2px;
        }
        &.active::after {
          position: absolute;
          bottom: 0;
          left: 0;
          z-index: -1;
          width: 86px;
          height: 12px;
          margin-bottom: -4px;
          background: #fff0d1;
          content: '';
        }
      }
      .select {
        position: absolute;
        right: 0;
        display: flex;
        align-items: center;
        color: #111;
        font-weight: 300;
        font-size: 22px;
        font-family: PingFangSC-Light, PingFang SC;
        line-height: 24px;
        img {
          position: relative;
          top: 0;
          width: 24px;
          height: 24px;
          margin-top: -0.5px;
          margin-left: 4px;
        }
      }
    }

    .select-cates {
      display: flex;
      margin-top: 22px;
      .select-item-wrapper {
        width: 196px;
        margin-right: 18px;
        &:last-child {
          margin-right: 0;
        }
        .select-item {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 196px;
          background: #ffffff;
          &::after {
            @include hairline(#f0f0f0);
            border-width: 1px;
            border-radius: 32px;
          }
          .img-select {
            width: 160px;
            height: 160px;
            object-fit: contain;
            border-radius: 12px;
          }
          .select-tag {
            position: absolute;
            bottom: 12px;
            left: 14px;
            z-index: 999;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            width: calc(100% - 28px);
            height: 36px;
            padding: 1px;
            overflow: hidden;
            background: #fff4f3;
            border-radius: 18px;
            .img-tag {
              position: relative;
              width: 34px;
              height: 34px;
              margin-right: 4px;
              border-radius: 18px;
            }
            .tag-text {
              @include ellipsis();
              color: #ff483c;
              font-weight: 300;
              font-size: 18px;
              font-family: PingFangSC-Light, PingFang SC;
              line-height: 25px;
            }
          }
        }
        .item-title {
          display: inline-block;
          width: 100%;
          margin-top: 24px;
          color: #000;
          font-weight: 400;
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          line-height: 24px;
          text-align: center;
        }
        .item-price {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 12px;
          .price-text {
            color: #111;
            font-weight: 300;
            font-size: 20px;
            font-family: PingFangSC-Light, PingFang SC;
            line-height: 22px;
          }
          .price-icon {
            width: 8px;
            height: 14px;
            margin: -1px 0 0 7px;
          }
        }
      }
    }
  }
}
</style>
